<script setup lang="ts">
import { UiNotFoundPage } from "@packages/component-library";

definePageMeta({
  layout: "default",
});

const error = useError();
if (error && error.statusCode !== 404) {
  clearError({ redirect: undefined });
}

const statusCode = computed(() => error?.statusCode ?? 404);
</script>

<template>
  <div class="not-found">
    <UiNotFoundPage :error-code="statusCode" />
  </div>
</template>

<style scoped lang="scss">
.not-found {
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
